<template>
  <v-container fluid grid-list-lg class="pt-3">
    <v-layout row wrap>
      <v-flex xs12 md3>
        <v-card style="margin-bottom: 20px;">
          <v-system-bar color="accent" dark window>
            <v-icon center>storage</v-icon>
            <v-toolbar-title class="ml-1">Роли</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon small @click="addRole" v-if="accesses.role_group_create" class="mx-0">
              <v-icon class="mx-0">add</v-icon>
            </v-btn>
          </v-system-bar>
          <v-layout row wrap>
            <v-flex xs12>
              <v-list subheader>
                <v-list-tile dense v-for="item in roles" :key="item.id" @click="editRole(item, true)">
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.name"></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn v-if="item.type!==2 && accesses.role_group_delete" @click.stop="deleteRole(item)" icon><v-icon color="red">close</v-icon></v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card>
          <v-system-bar color="accent" dark window>
            <v-icon center>device_hub</v-icon>
            <v-toolbar-title class="ml-1">Оргструктура</v-toolbar-title>
          </v-system-bar>
          <v-layout row wrap>
            <v-flex xs12 class="ma-2">
              <dantser-tree
                ref="typesTree"
                :selectMode="1"
                :source="treedata"
                @click-node="nodeClicked($event)"
              ></dantser-tree>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md9>
        <v-card>
          <v-system-bar color="accent" dark window>
            <v-icon center>playlist_add_check</v-icon>
            <v-toolbar-title class="ml-1">Права</v-toolbar-title>
          </v-system-bar>
          <v-layout row wrap>
            <v-flex v-if="adminRole && currentNode" xs12 class="pl-4 pb-0 mt-3"><span class="subheading">Роль: Администратор группы</span></v-flex>
            <v-flex v-show="!adminRole" xs12 class="pl-4 pb-0 mt-3" v-if="currentNode"><span class="subheading">Назначить роль на {{nodeName}}</span></v-flex>
            <v-flex v-show="!adminRole" xs12 class="pl-4 pb-0 mt-3" v-if="currentRole && !currentNode"><span class="subheading">{{currentRole.id ? 'Редактировать роль' : 'Добавить роль'}}</span></v-flex>
            <v-flex xs7 class="pl-4" v-show="!adminRole">
              <v-text-field v-model="currentRole.name" v-if="currentRole && !currentNode" single-line></v-text-field>
              <v-select v-if="currentNode" :items="all_roles" return-object item-text="name" item-value="name"
                        label="Выбранная роль" @input="editRole($event, false)" v-model="currentRole" no-data-text="Нет доступных ролей"></v-select>
            </v-flex>
            <v-flex xs5 v-show="!adminRole">
              <v-btn color="success" small dark @click="saveElement" v-if="currentRole || currentNode">Сохранить</v-btn>
            </v-flex>
            
            <v-flex xs12>
              <v-data-table  :items="interfaces" hide-actions :headers="headers">
                <template slot="items" slot-scope="props" v-if="currentRole || currentNode">
                  <td><span :class="{'pl-3':!props.item.is_module, 'body-2':props.item.is_module}">{{ props.item.name }}</span></td>
                  <td><v-checkbox :disabled="adminRole" v-model="props.item.access[0].check" v-if="props.item.access[0]" hide-details></v-checkbox></td>
                  <td><v-checkbox :disabled="adminRole" v-model="props.item.access[1].check" v-if="props.item.access[1]" hide-details></v-checkbox></td>
                  <td><v-checkbox :disabled="adminRole" v-model="props.item.access[2].check" v-if="props.item.access[2]" hide-details></v-checkbox></td>
                  <td><v-checkbox :disabled="adminRole" v-model="props.item.access[3].check" v-if="props.item.access[3]" hide-details></v-checkbox></td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex'
  
  export default {
    name : 'Roles',
    
    data() {
      return {
        currentRole: null,
        currentNode: null,
        treedata: [],
        nodeName: '',
        adminRole: false,
        all_roles: [],
        interfaces:[],
        headers: [
          { text: 'Модуль/Интерфейс', align: 'left', sortable: false},
          { text: 'Доступ', sortable: false},
          { text: 'Создание', sortable: false},
          { text: 'Редактирование', sortable: false},
          { text: 'Удаление', sortable: false},
        ],
      }
    },
  
    computed:{
      accesses(){
        return this.$store.state.app.account.accesses['interfaces'] || {}
      },
      ...mapGetters('orgstructure/interfaces', {
        roles: 'group_roles'
      })
    },
  
    created(){
      if(!this.accesses.role_group_access ){
        this.$store.commit(`app/layout/setRouteStatus`, 'accessDenied')
      } else {
        this.getTree()
        this.getRoles()
      }
    },
    
    methods : {
      getTree(){
        this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
          this.treedata = usersTree
        })
      },
  
      getRoles(){
        this.$store.dispatch('orgstructure/interfaces/list', 'group')
      },
      
      nodeClicked(node){
        if(this.accesses.role_group_update){
          this.currentNode = node
          this.currentRole = null
          this.interfaces = []
          if (node.parent_id === null || (node.parent_id === this.treedata[0].id && node.element_type === 'post')) {
            this.nodeName = 'Администратор группы'
            this.$store.dispatch('orgstructure/interfaces/relations', {type:node.element_type, id: node.id}).then( response => {
              this.interfaces = response.interfaces
              this.interfaces.forEach(interfaceitem => {
                interfaceitem.access.forEach(item => {
                  item.check = true
                })
              })
              this.adminRole = true
            })
          } else {
            this.adminRole = false
            if(node.element_type==='container') {
              this.nodeName = 'подразделение "'+node.name+'"'
            } else {
              this.nodeName = 'пост "'+node.name+'"'
            }
            this.$store.dispatch('orgstructure/interfaces/relations', {type:node.element_type, id: node.id}).then( response => {
              this.currentRole = response.role
              this.interfaces = response.interfaces
              if(response.role.personal === 0) {
                this.all_roles = [{id: "", name: "Индивидульный набор", personal: 1, type: 3}].concat(this.roles)
              } else {
                this.all_roles = [response.role].concat(this.roles)
              }
            })
          }
        }
      },
  
      addRole(){
        this.$store.dispatch('orgstructure/interfaces/getInterfaces', 'group').then( response => {
          this.interfaces = response.group
        })
        this.currentNode = null
        this.currentRole = {
          id: '',
          name: 'Новая роль'
        }
      },
  
      editRole(item, make_null){
        if(this.accesses.role_group_update){
          if(item.id){
            this.interfaces = []
            this.$store.dispatch('orgstructure/interfaces/relations', {type: 'role', id: item.id}).then( response => {
              this.currentRole = response.role
              this.interfaces = response.interfaces
            })
            if(make_null) this.currentNode = null
          } else {
            this.$store.dispatch('orgstructure/interfaces/getInterfaces', 'group').then( response => {
              this.interfaces = response.group
            })
          }
        }
      },
      
      deleteRole(item){
        this.$store.dispatch('orgstructure/interfaces/delete', {id:item.id, type:'group'}).then( response => {
          if( this.currentRole && item.id === this.currentRole.id ) this.currentRole = null
        })
      },
  
      saveElement(){
        if(this.currentNode){
          this.$store.dispatch('orgstructure/interfaces/attach', {
            role_id: this.currentRole.id,
            element_id: this.currentNode.id,
            element_type: this.currentNode.element_type,
            interfaces: this.interfaces
          }).then( response => {
            this.currentRole = null
            this.currentNode = null
          })
        } else {
          if( !this.currentRole.id ) {
            let data = {
              personal : 0,
              role_name : this.currentRole.name,
              interfaces : this.interfaces
            }
            this.$store.dispatch('orgstructure/interfaces/create', {type: 'group', data: data}).then( response => {
              this.currentRole = null
              this.currentNode = null
            })
          } else {
            let data = {
              role_name: this.currentRole.name,
              interfaces: this.interfaces
            }
            this.$store.dispatch('orgstructure/interfaces/update', {id: this.currentRole.id, type: 'group', data: data}).then( response => {
              this.currentRole = null
              this.currentNode = null
            })
          }
        }
      }
      
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Roles/Roles.vue